const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  container: {
    position: 'relative',
  },
  suggestionsContainerOpen: {
    minHeight: 48,
    border: '1px solid',
    borderColor: theme.palette.grey.main,
  },
  suggestion: {
    display: 'block',
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.grey.main,
  },
  suggestionText: {
    whiteSpace: 'normal',
    [theme.breakpoints.down('sm')]: {
      lineHeight: 1.4,
    },
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    maxHeight: 240,
    overflowY: 'auto',
  },
  spinnerContainer: {
    border: '1px solid',
    borderColor: theme.palette.grey.light,
    position: 'absolute',
    backgroundColor: '#ffffff',
    zIndex: 999,
  },
  spinner: {
    animationDuration: '600ms',
    padding: theme.spacing(1),
    left: '50%',
    position: 'relative',
  },
});

export default styles;
